// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3Qfto","container":"styles_container__3MV1T","title":"styles_title__ZApG-","wrapper":"styles_wrapper__2EX3B","answer":"styles_answer__1w6bF"};